/** Points required for £1 off at checkout (100 points = £1). */
export const LOYALTY_POINTS_PER_POUND = 100;

export function loyaltyPointsGbpValue(points: number) {
  return Math.floor(Math.max(0, points) / LOYALTY_POINTS_PER_POUND);
}

export function formatLoyaltyPoints(points: number) {
  return Math.max(0, Math.floor(points)).toLocaleString("en-GB");
}

export function formatLoyaltyPointsGbpValue(points: number) {
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(loyaltyPointsGbpValue(points));
}
